<template>
  <div>
    <p class="page-title">小语种报告</p>
    <panel :url="url"
           :bg-url="bgUrl"
           :content="content"
           bg-align="left-bottom">
      <div slot="section">
        <p>我们提供地道翻译、大数据报告</p>
        <p>为您精细化运营采购商</p>
      </div>
    </panel>
  </div>
</template>

<script>
import panel from './panel-2'
export default {
  components: {
    panel,
  },
  data () {
    return {
      url: require('@/assets/access_images/access-google-ads-lang.png'),
      bgUrl: require('@/assets/access_images/access-google_bg.png'),
      content: [
        '没有选择西语投放，您错过的是',
        '21个国家的潜在市场'
      ]
    }
  },
}
</script>

<style lang="scss" scoped>
.page-title {
  padding: 20px;
  font-weight: 600;
  font-size: 15px;
}
</style>